// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__2W7HM","hover-typeB-r":"button_hover-typeB-r__1Uiss"};